const fileInput = document.querySelector('.form__item--file input[type="file"]');
const fileNameSpan = document.querySelector('.form__item--file span');

if (fileInput && fileNameSpan) {
  fileInput.addEventListener('change', function() {
    const fileName = fileInput.files.length > 0 ? fileInput.files[0].name : 'Nahrát foto (volitelné)';
    fileNameSpan.textContent = fileName;
  });
}
